export const getFieldMapsUrl = (projectNumber?: string) => {
  const baseUrl = window._env_.FIELD_MAPS_BASE_URL;
  if (!projectNumber) return baseUrl;
  return `${baseUrl}?projectNumber=${encodeURIComponent(projectNumber)}`;
};

export const openFieldMaps = (projectNumber?: string) =>
  window.open(getFieldMapsUrl(projectNumber), '_blank', 'noopener,noreferrer');
